export default __webpack_public_path__ + "static/media/lock.deffc599.svg";